export default __webpack_public_path__ + "static/media/avatar_cow3.6dda380a.mp3";